"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarMenuProvider = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const state_1 = require("./state");
const ToolbarMenuProvider = ({ children, ...rest }) => {
    const _menu = rest.menu;
    const reactId = React.useId();
    // biome-ignore lint/correctness/useExhaustiveDependencies: props spread creates new object each render
    const state = React.useMemo(() => new state_1.ToolbarMenuState(rest, reactId), [rest, reactId]);
    return React.createElement(context_1.context.Provider, { value: state }, children);
};
exports.ToolbarMenuProvider = ToolbarMenuProvider;
